// Which links open in a new tab: booking and chat apps (and other sites) do, pages on
// mahimabali.com stay in the same tab. open.mahimabali.com is a separate app, so it gets a new tab.
const NEW_TAB_HOSTS = /(^|\.)(playtomic\.(io|com)|rezerv\.co|wa\.me|whatsapp\.com)$|^open\.mahimabali\.com$/i
const SITE_HOSTS = /^(www\.)?mahimabali\.com$/i

export const opensNewTab = (url) => {
  if (!url || typeof url !== 'string') return false
  if (!/^https?:\/\//i.test(url)) return false // relative links, #anchors, mailto:, tel:
  try {
    const host = new URL(url).hostname
    if (NEW_TAB_HOSTS.test(host)) return true
    return !SITE_HOSTS.test(host)
  } catch {
    return false
  }
}

// Spread onto an <a>: {...ext(href)}
export const ext = (url) => (opensNewTab(url) ? { target: '_blank', rel: 'noopener noreferrer' } : {})
